export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-w.cb5a73a6.png";